import {mapActions, mapGetters} from 'vuex'
export default {
    computed: {
        ...mapGetters({
            documents: 'DocumentStore/getDocuments',
            searchQuery: 'DocumentStore/getSearchQuery',
            region: 'DocumentStore/getRegion',
            filterValues: 'DocumentStore/getFilterValues',
            orderBy: 'DocumentStore/getSortOrder'
        })
    },

    methods: {
        ...mapActions({
            setFilteredDocumentsInDocumentStore: 'DocumentStore/setFilteredDocuments'
        }),
        
        filterDocuments() {  
            var filteredDocuments = this.documents

            if(this.filterValues.length) {
                filteredDocuments = filteredDocuments.filter(doc => {
                    const ingredients = doc.activeingredients.map(item => {
                        return item.title
                    })

                    const found = this.filterValues.some(r => ingredients.indexOf(r) >= 0)
                    return found
                })
            }

            if(this.searchQuery) {
                filteredDocuments = filteredDocuments.filter(doc => {
                    return doc.title.toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1
                })
            }

            /* NI Decommissioning: Now forcing only documents from UK to be visible... */
            /* 1 is already the default, but just enforcing it here as a precaution */
            /* Dear Future Dev: Revert the commit that introduced this to restore region switching */
            filteredDocuments = filteredDocuments.filter(doc => {
                return doc.region === 1
            })

            if(parseInt(this.orderBy) === 1) {
                filteredDocuments = filteredDocuments.sort((a, b) => a.title.localeCompare(b.title))
            }

            if(parseInt(this.orderBy) === 2) {
                filteredDocuments = filteredDocuments.sort((a, b) => b.title.localeCompare(a.title))
            }

            this.setFilteredDocumentsInDocumentStore(filteredDocuments)
        },

        filterSearch(docs) {  
            var filteredDocuments = docs

            if(this.filterValues.length) {
                filteredDocuments = filteredDocuments.filter(doc => {
                    const ingredients = doc.activeingredients.map(item => {
                        return item.title
                    })

                    const found = this.filterValues.some(r => ingredients.indexOf(r) >= 0)

                    return found
                })
            }

            if(this.searchQuery) {
                filteredDocuments = filteredDocuments.filter(doc => {
                    return doc.title.toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1
                })
            }

            /* NI Decommissioning: Now forcing only documents from UK to be visible... */
            /* 1 is already the default, but just enforcing it here as a precaution */
            /* Dear Future Dev: Revert the commit that introduced this to restore region switching */
            filteredDocuments = filteredDocuments.filter(doc => {
                return doc.region === 1
            })

            if(parseInt(this.orderBy) === 1) {
                filteredDocuments = filteredDocuments.sort((a, b) => a.title.localeCompare(b.title))
            }

            if(parseInt(this.orderBy) === 2) {
                filteredDocuments = filteredDocuments.sort((a, b) => b.title.localeCompare(a.title))
            }

            return filteredDocuments
        }
    }
}